// Add your custom JS here.

document.addEventListener('DOMContentLoaded', function () {
	// Accordion
	document.querySelectorAll('.accordion__head').forEach(function (head) {
		head.addEventListener('click', function () {
			var accordion = this.closest('.accordion');
			var body = accordion.querySelector('.accordion__body');
			var isOpen = accordion.classList.contains('open');

			if (isOpen) {
				accordion.classList.remove('open');
				body.style.height = '0px';
			} else {
				accordion.classList.add('open');
				body.style.height = body.scrollHeight + 'px';
			}
		});
	});

	// Lazy loading images
	var lazyImages = document.querySelectorAll('img.lazy');
	if ('IntersectionObserver' in window) {
		var imageObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var img = entry.target;
					img.src = img.dataset.src;
					img.classList.add('loaded');
					imageObserver.unobserve(img);
				}
			});
		});
		lazyImages.forEach(function (img) { imageObserver.observe(img); });
	} else {
		lazyImages.forEach(function (img) {
			img.src = img.dataset.src;
			img.classList.add('loaded');
		});
	}

	// Gallery Swiper
	var galleryEl = document.querySelector('.in-person__gallery-slider');
	if (galleryEl && typeof Swiper !== 'undefined') {
		new Swiper(galleryEl, {
			slidesPerView: 'auto',
			spaceBetween: 14,
			grabCursor: true,
			freeMode: {
				enabled: true,
				momentum: true,
				momentumRatio: 0.5,
			},
		});
	}

	// About read more / ver menos
	var aboutBtn  = document.querySelector('.in-person__about-readmore');
	var aboutWrap = document.querySelector('.in-person__about-wrap');
	if (aboutBtn && aboutWrap && typeof gsap !== 'undefined') {
		var aboutFade    = aboutWrap.querySelector('.in-person__about-fade');
		var isExpanded   = false;
		var collapsedH   = window.innerWidth >= 992 ? 190 : 200;

		aboutBtn.addEventListener('click', function () {
			if (!isExpanded) {
				var fullH = aboutWrap.scrollHeight;
				gsap.to(aboutWrap, {
					height: fullH,
					duration: 0.6,
					ease: 'power2.out',
					onComplete: function () {
						gsap.set(aboutWrap, { height: 'auto', overflow: 'visible' });
					}
				});
				if (aboutFade) gsap.to(aboutFade, { opacity: 0, duration: 0.3 });
				aboutBtn.textContent = aboutBtn.dataset.less;
				isExpanded = true;
			} else {
				gsap.set(aboutWrap, { height: aboutWrap.offsetHeight, overflow: 'hidden' });
				gsap.to(aboutWrap, {
					height: collapsedH,
					duration: 0.5,
					ease: 'power2.inOut'
				});
				if (aboutFade) gsap.to(aboutFade, { opacity: 1, duration: 0.3, delay: 0.2 });
				aboutBtn.textContent = aboutBtn.dataset.more;
				isExpanded = false;
			}
		});
	}

	// Duo Swiper
	var duoEl = document.querySelector('.in-person__duo-swiper');
	var duoPrev = document.querySelector('.duo-prev');
	var duoNext = document.querySelector('.duo-next');
	if (duoEl && typeof Swiper !== 'undefined') {
		new Swiper(duoEl, {
			slidesPerView: 1,
			spaceBetween: 0,
			grabCursor: true,
			pagination: {
				el: '.in-person__duo-pagination',
				clickable: true,
			},
			navigation: duoPrev && duoNext ? {
				prevEl: duoPrev,
				nextEl: duoNext,
			} : false,
			breakpoints: {
				992: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 50,
				}
			}
		});
	}

	// Scroll animations
	var animatedEls = document.querySelectorAll('.animate-on-scroll');
	if ('IntersectionObserver' in window) {
		var animObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate');
					animObserver.unobserve(entry.target);
				}
			});
		}, { threshold: 0.15 });
		animatedEls.forEach(function (el) { animObserver.observe(el); });
	}
});